<template>
  <div id="regSw">
    <el-dialog
      :title="`為了您帳號的安全性，請先開啟通知權限。`"
      custom-class="lg-size"
      :visible.sync="checkPermissionDialog"
      :close-on-click-modal="false"
      :show-close="false"
      center
    >
      <div class="stepWrap">
        <template
          v-for="(v,i) in [
            {id:1, desc:'點擊網址左邊圖示'},
            {id:2, desc:'將位置、通知設定為「允許」'},
            {id:3, desc:'關掉設定視窗，點擊「重新載入」'}
          ]"
        >
          <div
            :key="'block'+v.id"
            class="step"
          >
            <p class="title">
              Step {{ v.id }}
            </p>
            <p class="desc">
              {{ v.desc }}
            </p>
            <img
              :src="require(`@/assets/img/login/notify${v.id}.png`)"
              alt=""
            >
          </div>
          <div
            v-if="i+1<3"
            :key="'arrow'+v.id"
            class="step_arrow"
          >
            <i
              class="el-icon-arrow-right"
              aria-hidden="true"
            />
          </div>
        </template>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="handleClickGranted"
        >確定</el-button>
        <el-button
          v-if="$route.name !== 'LoginMain'"
          type="danger"
          round
          @click="handleClickLogout"
        >登出</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getApps, initializeApp } from 'firebase/app'
import { getMessaging, getToken, deleteToken, onMessage, isSupported } from 'firebase/messaging'
import { checkIsLoginValid } from '@/js/utils/index.js'
import * as Sentry from '@sentry/vue'

export default {
  data () {
    return {
      checkPermissionDialog: false,
      serviceWorkerRegistration: null,
      receiveNotificationsTokenRetryCount: 0,
      isSWRegistering: false
    }
  },
  mounted () {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', event => {
        if (event.data.Login) {
          this.$emit('login', event.data)
        } else if (event.data.Logout) {
          this.$logoutCommunity()
        }
      })
    }
  },
  methods: {
    async registerServiceWorker () { // 註冊serviece worker
      if (this.isSWRegistering) return
      this.isSWRegistering = true
      if (kingetcareFb && fbMessaging) {
        await this.receiveNotificationsToken()
        return
      }
      const discardedServiceWorkerUrl = `${process.env.NODE_ENV === 'development' ? '' : '/mgmt'}/serviceWorker.js`
      // deleteToken 時，該方法會使用 firebase service worker 預設檔案路徑建立預設的 service worker，若此路徑無檔案則無法調用此方法，故更新此檔案的路徑位置
      const serviceWorkerUrl = `${process.env.NODE_ENV === 'development' ? '' : '/mgmt'}/firebase-messaging-sw.js`

      // 檢查並取消註冊舊的 service worker
      await this.unregisterDiscardedServiceWorker(discardedServiceWorkerUrl)

      kingetcareFb = getApps().filter(x => x.name === 'kingnetcare').length === 1 ? getApps().filter(x => x.name === 'kingnetcare')[0] : initializeApp(firebaseConfig, 'kingnetcare')
      let mgmtServiceWorker = null
      try {
        const registrations = await navigator.serviceWorker.getRegistrations()
        mgmtServiceWorker = registrations.find((item) => item.active?.scriptURL === `${window.location.origin}${serviceWorkerUrl}`)
      } catch (e) {
        console.log(e)
      }
      if (!mgmtServiceWorker) {
        let reg
        try {
          // 註冊新的 service worker（因 deleteToken 會呼叫到預設路徑註冊 service worker）
          // 產品部署時、多台主機逐一更新，可能取用到舊的主機、此時會無法取得新 service worker 檔案
          // 目前 cdn 與服務 domain 不一致，故無法取用 cdn 中的 service worker 來進行註冊
          reg = await navigator.serviceWorker.register(serviceWorkerUrl)
        } catch (error) {
          console.error(`service woker 註冊失敗 - ${serviceWorkerUrl}`, error)
          Sentry.setContext('service worker', {
            url: serviceWorkerUrl
          })
          Sentry.captureException(error)
        }
        if (!reg) {
          // 註冊舊的 service worker
          try {
            reg = await navigator.serviceWorker.register(discardedServiceWorkerUrl)
          } catch (error) {
            console.error(`service woker 註冊失敗 - ${discardedServiceWorkerUrl}`, error)
            Sentry.setContext('service worker', {
              url: discardedServiceWorkerUrl
            })
            Sentry.captureException(error)
          }
        }
        if (reg) {
          // 新舊任一註冊成功
          this.serviceWorkerRegistration = reg
          fbMessaging = getMessaging(kingetcareFb)
          this.checkPermission()
        } else {
          // 兩者都註冊失敗
          this.$alert('推播註冊失敗！請將通知權限封鎖後再次允許。', '警告', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false
          }).then(() => {
            localStorage.setItem('serviceWorker', 'false')
          })
        }
      } else {
        this.serviceWorkerRegistration = mgmtServiceWorker
        fbMessaging = getMessaging(kingetcareFb)
        this.checkPermission()
      }
      onMessage(fbMessaging, (payload) => {
        console.log('Message received. ', payload)
      })
      this.isSWRegistering = false
    },
    // 取消註冊舊的 service worker 的方法
    async unregisterDiscardedServiceWorker (discardedServiceWorkerUrl) {
      try {
        // 取得所有已註冊的 service worker
        const registrations = await navigator.serviceWorker.getRegistrations()
        // 尋找符合 discardedServiceWorkerUrl 的 service worker
        const discardedSW = registrations.find((item) =>
          item.active?.scriptURL === `${window.location.origin}${discardedServiceWorkerUrl}`
        )

        // 如果找到舊的 service worker，則取消註冊
        if (discardedSW) {
          await discardedSW.unregister()
        }
      } catch (error) {
        console.error('取消註冊舊的 service worker 時發生錯誤:', error)
        Sentry.captureException(error)
      }
    },
    clearFirebaseMessagingIndexedDb () {
      // 清除 firebase messaging 相關的 IndexedDB 資料庫
      indexedDB.databases().then((dbs) => {
        dbs.forEach((db) => {
          if (db.name.includes('firebase') || db.name.includes('messaging')) {
            indexedDB.deleteDatabase(db.name)
          }
        })
      }).catch((error) => {
        console.error('獲取 IndexedDB 資料庫列表時發生錯誤:', error)
        Sentry.captureException(error)
      })
    },
    async receiveNotificationsToken () { // 取得push token
      let token = ''
      try {
        const options = {}
        if (this.serviceWorkerRegistration) options.serviceWorkerRegistration = this.serviceWorkerRegistration
        // 檢查登入是否有效
        const isLoginValid = checkIsLoginValid()
        const getPushTokenTime = localStorage.getItem('getPushTokenTime')
        const isPushTokenExpired = getPushTokenTime ? (new Date().getTime() - getPushTokenTime) > 24 * 60 * 60 * 1000 : true
        if (!isLoginValid && isPushTokenExpired) {
          // 如果登入無效且 token 已超過 24 小時，先刪除現有推播 token，以避免一 token 24 小時內便碰撞超過 300 次的特殊情形 (#88497)
          // 高碰撞率將導致 A 管理員掃描 QRCode 登入時，B 管理員進入到登入頁便能以 A 管理員的身份進行登入，是資安層級的 issue
          // 但這樣的處理方式將使 loading 時間至少長達 1 秒
          try {
            localStorage.removeItem('QRcodeToken') // 移除後將顯示 loading 畫面，避免使用即將失效的 QRCode 進行登入
            await deleteToken(fbMessaging) // 和 firebase 申請刪除舊的推播 token
          } catch (error) {
            console.error('刪除舊 token 失敗:', error)
            Sentry.captureException(error)
          }
        }
        try {
          token = await getToken(fbMessaging, options)
          localStorage.setItem('getPushTokenTime', new Date().getTime())
        } catch (error) {
          console.error('獲取推播 token 失敗:', error)
          Sentry.captureException(error)
          try {
            // 取消訂閱推播
            const subscription = await this.serviceWorkerRegistration.pushManager.getSubscription()
            if (subscription) await subscription.unsubscribe()
          } catch (error) {
            console.error('取消訂閱推播時發生錯誤:', error)
            Sentry.captureException(error)
          }
          this.clearFirebaseMessagingIndexedDb()
        }
        if (token) {
          this.$emit('getToken', token)
          this.isSWRegistering = false
        }
        this.receiveNotificationsTokenRetryCount = 0
      } catch (e) {
        console.error(e)
        if (this.receiveNotificationsTokenRetryCount < 5) {
          this.receiveNotificationsToken()
          this.receiveNotificationsTokenRetryCount++
        }
        else return
      }
      try {
        const loginUserInfoJSON = localStorage.getItem('loginUserInfo')
        const loginUserInfo = loginUserInfoJSON ? JSON.parse(loginUserInfoJSON) : {}
        if (this.$getCookie('comLoginToken') && token && loginUserInfo && !loginUserInfo.IsFromEip && JSON.parse(localStorage.getItem('loginStatus'))) {
          axios(`${process.env.VUE_APP_CORE_URL}/api/Account/BrowserPushToken`, {
            method: 'patch',
            data: {
              BrowserPushToken: token
            },
            headers: {
              KingnetAuth: `Cookies ${this.$getCookie('comLoginToken').replace('token=', '')}`,
              'content-type': 'application/json-patch+json'
            }
          }).then(res => {
            console.log(res)
          }).catch(err => {
            console.log(err.response)
          })
        }
      } catch (error) {
        console.error(error)
      }
    },
    async checkPermission () { // 確認權限 default/granted/denied
      let isSupporterMessaging = false
      try {
        isSupporterMessaging = await isSupported()
      } catch (e) {
        console.log(e)
      }
      if ('Notification' in window && isSupporterMessaging) {
        if (Notification.permission === 'default' || Notification.permission === 'undefined') {
          this.checkPermissionDialog = true
        }
        Notification.requestPermission((permission) => {
          if (permission === 'granted') {
            this.registerServiceWorker()
            this.checkPermissionDialog = false
          } else {
            this.checkPermissionDialog = true
          }
        })
      } else {
        // 身為 PD，希望可以默許使用 iPhone 版 Chrome 的情境，以避免零星客訴 #77798
        // 五年前想擋沒寫好、沒擋成功，零星使用者鑽漏洞使用，但也沒遇到相關客訴
        // 近期修 Sentry 把阻擋修好，反而造成客訴，經 PD 評估後不進行此阻擋
        // 若為使用手機所造成的客訴，RD 將不會進行處理
        // this.$alert('請檢查是否你的瀏覽器支援。', '警告', {
        //   confirmButtonText: '確定',
        //   type: 'warning',
        //   showClose: false,
        //   roundButton: true,
        //   closeOnClickModal: false
        // }).then(() => {
        //   this.$logoutCommunity()
        // })
      }
    },
    handleClickGranted () {
      this.checkPermissionDialog = false
      location.reload()
    },
    handleClickLogout () {
      this.checkPermissionDialog = false
      if (!(window.location.href.indexOf('login') > -1)) {
        localStorage.setItem('serviceWorker', 'false')
        this.$logoutCommunity()
      } else {
        localStorage.setItem('serviceWorker', 'false')
        location.reload()
      }
    }
  }
}
</script>

<style lang="sass" scoped>
#regSw
  ::v-deep .el-dialog
    +basicDialog
    z-index: 3500
  .stepWrap
    display: inline-flex
    flex-wrap: wrap
    justify-content: space-between
    align-items: center
    width: 100%
    .step
      width: 30%
      color: $mainFontColor
      img
        width: 100%
      p
        line-height: 1.2
    .title
      font-size: map-get($fontSize,xx-large)
      font-weight: bold
      margin-bottom: 5px
    .desc
      font-size: map-get($fontSize,small)
      margin-bottom: 10px
    .step_arrow
      margin-top: 50px
      font-size: 30px
      color: $mainColor
  @media (max-width:768px)
    ::v-deep .el-dialog.lg-size
      min-width: 300px
      width: 90%
      .stepWrap
        justify-content: center
        text-align: center
        .step
          width: 90%
          margin-bottom: 20px
          img
            width: 100%
        .step_arrow
          display: none
</style>
